import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'src/app/dialog/services/dialog.service';
import { RequestComponent } from '../request/request.component';
import { RequestService } from '../services/requests.services';

@Component({
  selector: 'app-request-detail-dialog',
  templateUrl: './request-detail-dialog.component.html',
  styleUrls: ['./request-detail-dialog.component.css']
})
export class RequestDetailDialogComponent {
  requestid = 0;

  dialogBoxSubscription?: Subscription;
  constructor(private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly requestService: RequestService,
    public dialogRef: MatDialogRef<RequestComponent>,
    private readonly dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.requestid = data.id;
    }

  ngOnInit() {

  }

    closeDialog() {
      this.dialogRef.close();
    }
}
